import { render, staticRenderFns } from "./c_input_item.vue?vue&type=template&id=4f723fd2&scoped=true&"
import script from "./c_input_item.vue?vue&type=script&lang=js&"
export * from "./c_input_item.vue?vue&type=script&lang=js&"
import style0 from "./c_input_item.vue?vue&type=style&index=0&id=4f723fd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f723fd2",
  null
  
)

export default component.exports